import { render, staticRenderFns } from "./PlansScreen.vue?vue&type=template&id=18333a1d&"
import script from "./PlansScreen.vue?vue&type=script&lang=js&"
export * from "./PlansScreen.vue?vue&type=script&lang=js&"
import style0 from "./PlansScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports